import { arrayOf, bool, number, oneOf, shape, string } from "prop-types"

import { linearLocation } from "../linearLocation"
import { timestamp } from "../timestamp"
import { uuid } from "../uuid"

import { task } from "./task"
import { technique, techniqueForm } from "./technique"

const STATUSES = [25, 50, 100]

export const roadwork = shape({
    createdAt: timestamp.isRequired,
    doneAt: timestamp,
    doneBy: string,
    isLogiroadRecommandation: bool,
    linearLocation: arrayOf(linearLocation).isRequired,
    status: oneOf(STATUSES),
    tasks: arrayOf(uuid.isRequired).isRequired,
    technique: technique.isRequired,
    updatedAt: timestamp.isRequired,
    uuid: uuid.isRequired,
    year: number.isRequired,
})

export const roadworkWithTasks = shape({
    createdAt: timestamp.isRequired,
    doneAt: timestamp,
    doneBy: string,
    isLogiroadRecommandation: bool,
    linearLocation: arrayOf(linearLocation).isRequired,
    status: oneOf(STATUSES),
    tasks: arrayOf(task.isRequired).isRequired,
    technique: techniqueForm.isRequired,
    updatedAt: timestamp.isRequired,
    uuid: uuid.isRequired,
    year: number.isRequired,
})

export const roadworkForm = shape({
    tasks: arrayOf(task),
    technique: techniqueForm.isRequired,
    uuid: uuid.isRequired,
    year: number.isRequired,
})